export default "__VITE_ASSET__0RwuzryU__"